
let TestModel = require('@/mixins/Forms/2022/TestModel')

module.exports = {

    mixins: [TestModel],

    data(){
        return {
            construction_inspection: {
                name: `A. Construction Inspection (NA7.6.3.1)`,
                rows: {
                    row_1: {
                        id: `1`,
                        question: `The demand responsive control is setup to communicate with the VEN using one of the following communication protocols: Wi-Fi, ZigBee, BACnet, Ethernet, or other wired or wireless bi-directional communication pathway. The demand responsive control is set up to communicate for the functional testing of NA7.6.3.2`,
                        code_reference:`NA7.6.3.1(a), §110.12(a)2`,
                        answer: false,
                    },
                },
                result: false,
            }
        }
    },

    mounted() {
        this.form = new Form({
            construction_inspection: this.construction_inspection,
            functional_test: this.functional_test,
            comments: '',
            testResult: false,
        }, false)
        this.loadFormData();
    },

    methods: {

        initTest() {
            if (!this.testIsReady) {
                return;
            }

            this.constructionInspectionEvaluation();
            this.functionalTestEvaluation();

            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
        },

        constructionInspectionEvaluation() {
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.rows, (question, i) => {
                if (!question.answer) {
                    this.form.construction_inspection.result = false;
                }
            })
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },


        hasMergedCells(question) {
            if (question.hasOwnProperty('merge_cells')) {
                return question.merge_cells;
            }
            return false;
        }
    },
}
